module.exports = __webpack_public_path__ + "static/media/flagSensitive.55d512c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Flags/flagSensitive.svg
// module id = 892
// module chunks = 0